import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pippo',
  templateUrl: './pippo.component.html',
  styleUrls: ['./pippo.component.css']
})
export class PippoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
